export class MimeTypeMapper {

    static getIconType(mimeType){
        switch (mimeType){
            case 'application/pdf':
            case 'application/x-pdf':
                return 'mdi mdi-file-pdf';
            case 'image/png':
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/apng':
                return 'mdi mdi-file-image';
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return 'mdi mdi-file-word';
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return 'mdi mdi-file-excel';
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                return 'mdi mdi-file-powerpoint';
            case 'application/zip':
                return 'mdi mdi-zip-box';
            case 'text/plain':
                return 'mdi mdi-file';
            default:
                return 'mdi mdi-file';

        }
    }

    static getLabelType(mimeType){
        switch (mimeType){
            case 'application/pdf':
            case 'application/x-pdf':
                return 'PDF Document';
            case 'image/png':
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/apng':
                return 'Image';
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return 'Word Document';
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return 'Excel File';
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                return 'Power Point File';
            default:
                return '';

        }
    }
}